import axios from 'axios';
import { getServerApi } from '../../config/deployment';
import { getUserToken } from '@/functions.js';

const API_GATEWAY_URL = `${getServerApi()}/api/contracts-gateway`;
const WEB_SOCKET_SERVER_ENDPOINT = getServerApi().indexOf('https') >= 0 ? '/websocket/' : '';
const WEB_SOCKET_SERVER_URL = `ws${getServerApi().substring(4)}${WEB_SOCKET_SERVER_ENDPOINT}`;
const DEALS_ENDPOINT = 'deals';
const CONTRACTS_ENDPOINT = 'contracts';
const SIGNATURES_ENDPOINT = 'signatures';
const DOCUMENTS_ENDPOINT = 'documents';

export default {
    subscribe(accountId, callback) {
        const socket = new WebSocket(WEB_SOCKET_SERVER_URL);
        socket.onmessage = (message) => {
            callback(JSON.parse(message.data));
        };
        socket.onopen = () => {
            socket.send(JSON.stringify({
                event: 'subscribeToEvents',
                accountId,
            }));
        };
    },

    async getDocumentForDeal(dealId) {
        const token = await getUserToken();
        const response = await axios.get(`${API_GATEWAY_URL}/${DEALS_ENDPOINT}/${dealId}/${DOCUMENTS_ENDPOINT}`, {
            params: { token },
        });

        return response.data;
    },

    async getContractSignatures(contractId) {
        const response = await axios.get(`${API_GATEWAY_URL}/${CONTRACTS_ENDPOINT}/${contractId}/${SIGNATURES_ENDPOINT}`);

        return response.data.signatures || [];
    },
}



// WEBPACK FOOTER //
// ./src/services/contract-documents/index.js